import { APIQueueTaskKind, type DocumentQueueTasks } from '@visorpro/client'

export interface CreateQueueTaskOption {
    label: string
    description: string
    /** A single kind is one task; several kinds are chained in order. */
    value: DocumentQueueTasks | DocumentQueueTasks[]
}

export const createQueueTaskOptions: CreateQueueTaskOption[] = [
    {
        label: 'Split, parse and embed',
        description:
            'Splits, parses and embeds the document as a chain of three tasks.',
        value: [
            APIQueueTaskKind.SPLIT_DOCUMENT,
            APIQueueTaskKind.PARSE_DOCUMENT,
            APIQueueTaskKind.EMBED_DOCUMENT,
        ],
    },
    {
        label: 'Parse and embed',
        description: 'Parses and embeds the document as a chain of two tasks.',
        value: [
            APIQueueTaskKind.PARSE_DOCUMENT,
            APIQueueTaskKind.EMBED_DOCUMENT,
        ],
    },
    {
        label: 'Split only',
        description: 'Splits the document in a single task.',
        value: APIQueueTaskKind.SPLIT_DOCUMENT,
    },
    {
        label: 'Parse only',
        description: 'Parses the document in a single task.',
        value: APIQueueTaskKind.PARSE_DOCUMENT,
    },
    {
        label: 'Embed only',
        description: 'Embeds the document in a single task.',
        value: APIQueueTaskKind.EMBED_DOCUMENT,
    },
    {
        label: 'Process document',
        description:
            'Splits, parses and embeds the document in a single task, then enables the new document version.',
        value: APIQueueTaskKind.PROCESS_DOCUMENT,
    },
]
